<template>
  <section style="margin-top:210px;">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="white-content">
            <p v-if="status==='decline'">
              Pagesa juaj eshte refuzuar. Ju lutem kontaktoni banken.
            </p>
            <p v-if="status==='approve'">
              Pagesa juaj është realizuar. Pako e blerë hyn në fuqi pas 48h, kur edhe do të pranoni të dhënat e llogarisë tuaj në e-mail.
            </p>
            <p v-if="status==='cancel'">
              Pagesa juaj eshte anuluar.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
export default {
  name: "Status",
  data: function() {
      return {
        status: 'approve',
        email: null
      }
  },
  created: function () {
      
      this.status = this.$route.params.status;
      this.email = this.$route.params.email
  }
};
</script>
